module.exports = __webpack_public_path__ + "img/rukavy_81_reflexni-zluta.1b7535a7.png";